(function () {
  var selectors = [
    '.date-picker-regular',
    '.date-picker-preorder',
    '.date-picker-dealoftheday',
    '.date-picker-valentines',
    '.date-picker-march8',
    '.date-picker-mothersday'
  ].join(',');

  function initPickers(attempt) {
    attempt = attempt || 0;

    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.datepicker) {
      if (attempt < 80) {
        window.setTimeout(function () { initPickers(attempt + 1); }, 50);
      }
      return;
    }

    var $ = window.jQuery;

    function attach() {
      $(selectors).each(function () {
        var $input = $(this);
        if (!$input.hasClass('hasDatepicker')) {
          $input.datepicker({ dateFormat: 'mm/dd/yy' });
        }
      });
    }

    if (document.readyState === 'loading') {
      $(attach);
    } else {
      attach();
    }
  }

  initPickers(0);
})();
